{
  "请输入颜色名称或色值": "Enter a color name or value",
  "请输入地域": "Enter the region",
  "租户全部用户": "All tenant users",
  "本部门": "Own department",
  "本部门及下级": "Own department and subdepartments",
  "指定部门": "Selected departments",
  "仅本人": "Self only",
  "角色管理": "Roles",
  "岗位管理": "Positions",
  "已删除": "Deleted",
  "新增角色": "Add role",
  "新增岗位": "Add position",
  "名称或编码": "Name or code",
  "搜索名称或编码": "Search name or code",
  "名称": "Name",
  "编码": "Code",
  "用户数据范围": "User data scope",
  "状态": "Status",
  "启用": "Enable",
  "停用": "Disable",
  "备注": "Notes",
  "操作": "Actions",
  "分配用户": "Assign users",
  "查看用户": "View users",
  "查看分配的用户": "View assigned users",
  "编辑": "Edit",
  "删除“{{name}}”？": "Delete “{{name}}”?",
  "有关联用户时无法删除，请先清空分配。": "Unassign all users before deleting.",
  "删除": "Delete",
  "取消": "Cancel",
  "已保存": "Saved",
  "{{action}}{{kind}}": "{{action}} {{kind}}",
  "新增": "Add",
  "角色": "Role",
  "岗位": "Position",
  "保存": "Save",
  "小写字母开头，只允许小写字母、数字和下划线，最多64字符": "Start with a lowercase letter; use only lowercase letters, numbers and underscores, up to 64 characters",
  "维护权限包含查看权限；角色维护及授权可授予所有业务权限，请谨慎分配。": "Write permissions include read access. Role management can grant all business permissions; assign carefully.",
  "重试": "Retry",
  "菜单及接口权限": "Menu and API permissions",
  "其他接口权限": "Other API permissions",
  "勾选目录或菜单将选择其全部权限；菜单显示还需满足上级目录权限。": "Selecting a directory or menu grants all its permissions. Menu visibility also requires parent directory permissions.",
  "多个启用角色取并集；范围不替代接口权限。": "Scopes from enabled roles are combined; they do not replace API permissions.",
  "重试部门加载": "Retry loading departments",
  "请选择 1–100 个部门": "Select 1–100 departments",
  "用户分配已保存": "User assignments saved",
  "{{name}} · 用户分配": "{{name}} · User assignments",
  "关闭": "Close",
  "仅调整可维护用户的分配，范围外成员保持不变。": "Only editable user assignments are changed. Members outside your scope are preserved.",
  "选择用户（可多选）": "Select users",
  "（停用）": " (Disabled)",
  "请输入部门名称": "Enter a department name",
  "名称最多 64 字符": "Name must be at most 64 characters",
  "顺序必须是整数": "Order must be an integer",
  "负责人最多 64 字符": "Leader must be at most 64 characters",
  "请输入有效的联系电话（3–32 字符）": "Enter a valid phone number (3–32 characters)",
  "部门已保存": "Department saved",
  "部门已创建": "Department created",
  "编辑部门": "Edit department",
  "新建子部门": "Add subdepartment",
  "新建部门": "Add department",
  "上级部门": "Parent department",
  "顶级部门": "Top-level department",
  "留空作为顶级部门；不可选择自身或下级部门。": "Leave blank for a top-level department. You cannot select this department or its descendants.",
  "部门名称": "Department name",
  "负责人": "Leader",
  "请输入负责人姓名": "Enter the leader's name",
  "联系电话": "Contact phone",
  "手机或固定电话": "Mobile or landline",
  "顺序": "Order",
  "同级部门按数字从小到大排列。": "Sibling departments are sorted in ascending order.",
  "正常": "Normal",
  "仅修改当前部门，不连带修改下级。": "Only this department is changed; subdepartments are unaffected.",
  "部门管理": "Departments",
  "删除后无法恢复。存在子部门或关联用户时，请先移动或删除子部门、调整用户归属；不会连带删除。": "Deletion cannot be undone. Move or delete subdepartments and reassign users first; related records are not deleted automatically.",
  "部门已删除": "Department deleted",
  "维护组织层级、负责人及联系方式": "Manage the organization hierarchy, leaders and contact details",
  "部门列表": "Departments",
  "没有符合条件的部门": "No matching departments",
  "暂无部门，点击“新建部门”建立组织层级": "No departments. Select “Add department” to create your organization hierarchy.",
  "暂无部门": "No departments",
  "刷新": "Refresh",
  "全部收起": "Collapse all",
  "全部展开": "Expand all",
  "请输入负责人": "Enter a leader",
  "请输入联系电话": "Enter a contact phone number",
  "创建时间": "Created at",
  "新建字典项": "New dictionary item",
  "编辑字典项 {{value}}": "Edit dictionary item {{value}}",
  "字典项已创建": "Dictionary item created",
  "字典项已更新": "Dictionary item updated",
  "字典标签": "Dictionary label",
  "例如：启用": "e.g. Enabled",
  "字典键值": "Dictionary value",
  "例如：active": "e.g. active",
  "落进业务数据的那个值；改它不会改已经存下来的数据": "The value stored in business records; changing it does not update existing records",
  "排序": "Sort order",
  "数字小的排在前面；留空按 0": "Lower numbers appear first; blank means 0",
  "标签颜色": "Label color",
  "可选，用于列表标签的颜色，例如 success、processing 或 #1677ff。留空表示不指定。": "Optional tag color, such as success, processing or #1677ff. Leave blank for no custom color.",
  "默认项": "Default item",
  "否": "No",
  "是": "Yes",
  "一个字典至多一个默认项；设成「是」时，原来那一项会被取消": "Each dictionary has at most one default item; selecting Yes replaces the previous default",
  "已停用": "Disabled",
  "停用的字典项不出现在对外查询里，历史数据仍能按值查到文案": "Disabled items are hidden from public queries; existing records can still resolve their labels",
  "这一项在什么场景下用": "When this item should be used",
  "预览": "Preview",
  "创建": "Create",
  "默认": "Default",
  "更新时间": "Updated at",
  "字典项": "Dictionary items",
  "顺序即对外查询的顺序": "This order is used by public queries",
  "删除字典项「{{name}}」？": "Delete dictionary item “{{name}}”?",
  "已经存进业务数据的键值不会被改动，只是这个字典不再提供它的文案。": "Existing record values are unchanged, but this dictionary will no longer provide their labels.",
  "已删除字典项「{{name}}」": "Dictionary item “{{name}}” deleted",
  "这个字典对外没有可选项：类型已停用，或者它的字典项都停用了": "No public options: the dictionary or all its items are disabled",
  "的答案 · 带 ★ 的是默认项": "result · ★ marks the default item",
  "新建字典": "New dictionary",
  "编辑字典 {{type}}": "Edit dictionary {{type}}",
  "字典已创建": "Dictionary created",
  "字典已更新": "Dictionary updated",
  "字典名称": "Dictionary name",
  "例如：用户状态": "e.g. User status",
  "字典编码": "Dictionary code",
  "例如：user_status": "e.g. user_status",
  "编码不可修改，要更换请新建一个字典。": "The code cannot be changed. Create another dictionary to use a different code.",
  "小写字母开头，只含小写字母、数字与下划线": "Start with a lowercase letter; use only lowercase letters, numbers and underscores",
  "停用的字典对外查询回答空列表，字典项不会被删除": "Disabled dictionaries return an empty public list; their items are preserved",
  "这个字典是给谁用的、有哪些约定": "Who uses this dictionary and its conventions",
  "{{count}} 项": "{{count}} items",
  "字典列表": "Dictionaries",
  "删除字典「{{name}}」？": "Delete dictionary “{{name}}”?",
  "该字典下没有字典项，删除不可撤销。": "This dictionary has no items. Deletion cannot be undone.",
  "该字典下的 {{count}} 个字典项会一起删除，且不可撤销。": "All {{count}} items in this dictionary will also be deleted. This cannot be undone.",
  "已删除字典「{{name}}」": "Dictionary “{{name}}” deleted",
  "请输入字典名称": "Enter a dictionary name",
  "字典名称最长 64 个字符": "Dictionary name must be at most 64 characters",
  "请输入字典编码": "Enter a dictionary code",
  "字典编码最长 64 个字符": "Dictionary code must be at most 64 characters",
  "只能用小写字母、数字与下划线，且以字母开头": "Use only lowercase letters, numbers and underscores, starting with a letter",
  "请输入字典标签": "Enter a dictionary label",
  "字典标签最长 64 个字符": "Dictionary label must be at most 64 characters",
  "请输入字典键值": "Enter a dictionary value",
  "字典键值最长 64 个字符": "Dictionary value must be at most 64 characters",
  "排序需要是整数": "Sort order must be an integer",
  "颜色最长 32 个字符": "Color must be at most 32 characters",
  "备注最长 255 个字符": "Notes must be at most 255 characters",
  "编辑菜单": "Edit menu",
  "新增菜单": "Add menu",
  "请输入菜单名称": "Enter a menu name",
  "请选择有效图标": "Select a valid icon",
  "排序必须是整数": "Sort order must be an integer",
  "请选择有效权限": "Select a valid permission",
  "请选择已有页面": "Select an existing page",
  "菜单已保存": "Menu saved",
  "菜单已创建": "Menu created",
  "这里只配置导航，不会自动创建新页面；隐藏或停用菜单不等于撤销接口权限。": "This configures navigation only; it does not create pages. Hiding or disabling a menu does not revoke API permissions.",
  "菜单名称": "Menu name",
  "类型": "Type",
  "目录": "Directory",
  "菜单": "Menu",
  "上级目录": "Parent directory",
  "顶级菜单": "Top-level menu",
  "页面路径": "Page path",
  "请选择页面": "Select a page",
  "图标": "Icon",
  "无图标": "No icon",
  "所需权限": "Required permission",
  "已登录用户": "Signed-in users",
  "维护权限也包含查看权限；目录权限对整个分支生效。": "Write permissions include read access; directory permissions apply to the entire branch.",
  "访问范围": "Access scope",
  "按所需权限": "By required permission",
  "仅内置管理员": "Built-in administrators only",
  "侧栏显示": "Sidebar visibility",
  "显示": "Visible",
  "隐藏": "Hidden",
  "菜单管理": "Menus",
  "只删除这个菜单；目录包含子菜单时，请先移动或删除子菜单。": "Only this menu is deleted. Move or delete child menus before deleting a directory.",
  "菜单已删除": "Menu deleted",
  "统一维护侧栏层级、顺序与可见范围，保存后立即更新": "Manage sidebar hierarchy, order and visibility; changes apply immediately after saving",
  "菜单列表": "Menus",
  "暂无菜单": "No menus",
  "名称或路径": "Name or path",
  "搜索菜单名称或页面路径": "Search menu name or page path",
  "访问权限": "Access permission",
  "仅管理员": "Administrators only",
  "侧栏": "Sidebar",
  "新增子菜单": "Add child menu",
  "更多": "More",
  "必须在部署环境中修改": "Must be changed in the deployment environment",
  "编辑配置": "Edit configuration",
  "查看配置": "View configuration",
  "确认修改": "Confirm changes",
  "配置键": "Configuration key",
  "来源：{{source}}": "Source: {{source}}",
  "已配置密钥，不回显": "Secret configured; value hidden",
  "当前生效值：{{value}}": "Effective value: {{value}}",
  "仅存入配置表，不自动注入环境变量。": "Stored in the configuration table only; not injected into environment variables.",
  "最后修改：{{name}} · {{date}}": "Last modified: {{name}} · {{date}}",
  "用户 #{{id}}": "User #{{id}}",
  "确认修改后，请在列表中统一保存。": "After confirming, save the changes from the list.",
  "由部署环境提供": "Provided by the deployment environment",
  "回落到环境或默认值": "Use environment or default value",
  "校验失败": "Validation failed",
  "未保存": "Unsaved",
  "只读": "Read-only",
  "待重启": "Restart required",
  "环境优先": "Environment override",
  "未配置": "Not configured",
  "已生效": "Active",
  "正在确认本部署是否允许重启…": "Checking whether this deployment allows restarts…",
  "无法确认本部署是否允许重启": "Unable to determine whether this deployment allows restarts",
  "重启 API 服务": "Restart API service",
  "已保存；{{count}} 项改动等待重启 API 生效": "Saved; {{count}} changes require an API restart",
  "重启 API 服务？": "Restart API service?",
  "当前进程会立刻退出。": "The current process will exit immediately.",
  "重启期间本页面会短暂失联。": "This page will briefly disconnect during the restart.",
  "未保存的修改不会生效。": "Unsaved changes will not take effect.",
  "重启": "Restart",
  "服务已重启，配置已生效": "Service restarted; configuration is active",
  "重启指令已发出，但 API 还没有恢复响应；请检查部署的守护进程与启动日志": "Restart requested, but the API is not responding yet. Check the process supervisor and startup logs.",
  "已重置": "Reset",
  "配置项": "Configuration item",
  "密文存储": "Encrypted storage",
  "配置值": "Configuration value",
  "无配置值": "No configuration value",
  "{{action}} {{name}}": "{{action}} {{name}}",
  "查看": "View",
  "删除配置？": "Delete configuration?",
  "重置配置？": "Reset configuration?",
  "删除后无法恢复。": "Deletion cannot be undone.",
  "将回落到环境变量或代码默认值。": "The environment variable or code default will be used.",
  "确认": "Confirm",
  "重置": "Reset",
  "{{count}} 项改动等待重启 API 生效": "{{count}} changes require an API restart",
  "重启服务": "Restart service",
  "配置分组": "Configuration groups",
  "新建分组": "Add group",
  "重试加载分组": "Retry loading groups",
  "配置": "Configuration",
  "分组改名": "Rename group",
  "空分组才能删除": "Only empty groups can be deleted",
  "删除分组": "Delete group",
  "删除「{{name}}」？": "Delete “{{name}}”?",
  "已删除分组": "Group deleted",
  "搜索配置": "Search configuration",
  "搜索名称或配置键": "Search name or configuration key",
  "新增配置": "Add configuration",
  "没有匹配的配置": "No matching configuration",
  "分组内暂无配置": "No configuration in this group",
  "{{count}} 项未保存": "{{count}} unsaved items",
  "放弃修改": "Discard changes",
  "保存 {{count}} 项": "Save {{count}} items",
  "已改名": "Renamed",
  "已新建分组": "Group created",
  "分组标识": "Group identifier",
  "创建后不可修改": "Cannot be changed after creation",
  "请输入分组标识": "Enter a group identifier",
  "以小写字母开头，仅支持小写字母、数字、下划线和连字符": "Start with a lowercase letter; use only lowercase letters, numbers, underscores and hyphens",
  "分组标识最多 64 字符": "Group identifier must be at most 64 characters",
  "例如 payment": "e.g. payment",
  "分组名称": "Group name",
  "请输入分组名称": "Enter a group name",
  "分组名称最多 64 字符": "Group name must be at most 64 characters",
  "例如支付配置": "e.g. Payment configuration",
  "已新增": "Added",
  "分组": "Group",
  "请选择分组": "Select a group",
  "选择已有分组": "Select an existing group",
  "请输入配置键": "Enter a configuration key",
  "以大写字母开头，仅支持大写字母、数字和下划线": "Start with an uppercase letter; use only uppercase letters, numbers and underscores",
  "最多 128 字符": "At most 128 characters",
  "配置键已存在": "Configuration key already exists",
  "例如 BUSINESS_NAME": "e.g. BUSINESS_NAME",
  "请输入配置值": "Enter a configuration value",
  "最多 16384 字符": "At most 16384 characters",
  "自定义项仅存入配置表，不自动注入环境变量。": "Custom items are stored in the configuration table only; not injected into environment variables.",
  "已配置并生效（留空表示不修改）": "Configured and active (leave blank to keep)",
  "已设置（留空表示不修改）": "Configured (leave blank to keep)",
  "未设置": "Not set",
  "未保存到配置表（当前生效值见下方）": "Not stored in the configuration table (effective value shown below)",
  "由环境变量提供": "Provided by an environment variable",
  "未设置，当前使用默认值 {{value}}": "Not set; using default {{value}}",
  "请输入数字": "Enter a number",
  "只能是：{{choices}}": "Allowed values: {{choices}}",
  "只能是 true 或 false": "Must be true or false",
  "配置表": "Configuration table",
  ".env 文件": ".env file",
  "部署环境变量": "Deployment environment variable",
  "代码默认值": "Code default",
  ".env 文件优先": ".env file override",
  "这个键写在部署的 .env 文件里，优先于配置表。要让页面上保存的值生效，先从 .env 里删掉 {{key}} 这一行。": "This key is set in the deployment's .env file, which overrides the configuration table. Remove the {{key}} line from .env for the saved value to take effect.",
  "部署环境变量优先": "Deployment environment override",
  "这个键由部署环境注入，优先于配置表。要让页面上保存的值生效，先在部署里去掉 {{key}}。": "This key is injected by the deployment environment, which overrides the configuration table. Remove {{key}} from the deployment for the saved value to take effect.",
  "当前进程会立刻退出，由部署的守护进程（容器重启策略 / systemd / pm2）重新拉起。": "The process will exit immediately and be restarted by the deployment supervisor (container restart policy / systemd / pm2).",
  "部署里没有守护进程时 API 不会自己回来；重启期间本页面会短暂失联。": "Without a process supervisor, the API will not restart automatically. This page will briefly disconnect during the restart.",
  "本地开发：这个进程退出后不会自己回来 —— 除非它是由会重新拉起进程的工具启动的（nest start --watch 在子进程退出时也会一起退出）。": "Local development: the process will not restart unless launched by a restarting supervisor (nest start --watch also exits when its child exits).",
  "重启后请回到终端重新运行 bun run dev；重启期间本页面会短暂失联。": "Run bun run dev again in the terminal after restarting. This page will briefly disconnect.",
  "本地开发不会自动回来：改一次文件让 watch 重启，或回到终端 Ctrl+C 重跑。": "Local development does not restart automatically: change a file to trigger watch, or press Ctrl+C and run again in the terminal.",
  "选择租户": "Select tenant",
  "租户管理": "Tenants",
  "当前租户：{{name}}": "Current tenant: {{name}}",
  "成员": "Member",
  "管理员": "Administrator",
  "所有者": "Owner",
  "全部角色": "All roles",
  "搜索租户名称或标识": "Search tenant name or identifier",
  "搜索成员姓名或邮箱": "Search member name or email",
  "搜索邀请租户": "Search inviting tenant",
  "租户已归档": "Tenant archived",
  "租户已恢复": "Tenant restored",
  "操作成功": "Success",
  "验证邮箱": "Verify email",
  "租户邀请": "Tenant invitation",
  "接受邀请": "Accept invitation",
  "发送验证邮件": "Send verification email",
  "验证邮箱后可接受邀请": "Verify your email to accept invitations",
  "列表筛选": "List filters",
  "搜索": "Search",
  "租户范围": "Tenant scope",
  "全部租户": "All tenants",
  "仅当前租户": "Current tenant only",
  "其他租户": "Other tenants",
  "成员角色筛选": "Filter member roles",
  "邀请角色筛选": "Filter invitation roles",
  "新建租户": "Add tenant",
  "新建成员": "Add member",
  "邀请成员": "Invite member",
  "我的租户": "My tenants",
  "请输入名称，最多 64 字": "Enter a name, up to 64 characters",
  "标识": "Identifier",
  "使用小写字母、数字和连字符，最多 64 字": "Use lowercase letters, numbers and hyphens, up to 64 characters",
  "创建租户": "Create tenant",
  "共 {{count}} 个租户": "{{count}} tenants",
  "暂无匹配租户": "No matching tenants",
  "恢复": "Restore",
  "归档": "Archive",
  "已归档": "Archived",
  "当前租户": "Current tenant",
  "切换": "Switch",
  "恢复这个租户？": "Restore this tenant?",
  "归档这个租户？": "Archive this tenant?",
  "成员可以再次进入。": "Members will be able to access it again.",
  "保留现有数据，停止新的会话和成员。": "Preserve existing data and prevent new sessions and members.",
  "成员管理": "Members",
  "成员姓名": "Member name",
  "请输入姓名，最多 64 字": "Enter a name, up to 64 characters",
  "登录邮箱": "Sign-in email",
  "请输入有效邮箱": "Enter a valid email address",
  "初始密码": "Initial password",
  "首次登录须修改密码；已有账号请使用邀请。": "The password must be changed at first sign-in. Invite existing accounts instead.",
  "密码须为 {{min}}–64 位且包含字母和数字": "Password must be {{min}}–64 characters and contain letters and numbers",
  "租户角色": "Tenant role",
  "创建并加入": "Create and add",
  "邮箱": "Email",
  "成员邮箱": "Member email",
  "发送邀请": "Send invitation",
  "共 {{count}} 名成员": "{{count}} members",
  "暂无匹配成员": "No matching members",
  "姓名": "Name",
  "{{name}}的角色": "Role for {{name}}",
  "移除此成员？": "Remove this member?",
  "移除": "Remove",
  "待处理邀请": "Pending invitations",
  "共 {{count}} 条邀请": "{{count}} invitations",
  "暂无匹配邀请": "No matching invitations",
  "邀请邮箱": "Invited email",
  "撤销邀请": "Revoke invitation",
  "收到的邀请": "Received invitations",
  "租户": "Tenant",
  "接受": "Accept",
  "拒绝": "Reject",
  "业务角色": "Business roles",
  "选择角色管理中的角色（可多选）": "Select business roles",
  "重新加载角色": "Reload roles",
  "权限取所有启用业务角色的并集，不会改变账号身份。": "Permissions from all enabled business roles are combined; the account identity is unchanged.",
  "需要角色维护及授权权限才能修改；未修改时保留原有分配。": "Role management permission is required to change assignments; unchanged assignments are preserved.",
  "部门 #{{id}}": "Department #{{id}}",
  "所属部门": "Department",
  "选择所属部门，可留空": "Select a department (optional)",
  "重新加载部门": "Reload departments",
  "每位用户归属一个部门；停用部门仅保留已有归属。": "Each user belongs to one department; disabled departments retain existing assignments only.",
  "只支持 JPEG / PNG / WebP 图片": "Only JPEG / PNG / WebP images are supported",
  "图片不能超过 5 MB": "Images must not exceed 5 MB",
  "照片已上传": "Photo uploaded",
  "共 {{count}} 张": "{{count}} photos",
  "上传照片": "Upload photo",
  "这个用户还没有照片": "This user has no photos",
  "照片 {{id}}": "Photo {{id}}",
  "永久移除 {{name}}": "Permanently remove {{name}}",
  "永久移除": "Permanently remove",
  "用户及登录数据已永久移除": "User and sign-in data permanently removed",
  "此操作不可撤销：将删除业务档案、照片记录、角色/岗位关联以及登录账号、凭据和全部会话。不能移除当前登录账号。": "This cannot be undone: the profile, photo records, role/position assignments, sign-in account, credentials and all sessions will be deleted. You cannot remove your current account.",
  "确认邮箱": "Confirm email",
  "请输入 {{email}}": "Enter {{email}}",
  "发放初始密码": "Issue initial password",
  "已为 {{email}} 发放初始密码，对方首次登录必须修改": "Initial password issued for {{email}}; it must be changed at first sign-in",
  "账号已有登录凭据，请改用「重置密码邮件」": "This account already has sign-in credentials. Use “Password reset email” instead.",
  "这是给对方的第一个登录密码": "This is the user's first sign-in password",
  "通过其它安全渠道转交。对方首次登录时会被强制修改密码。": "Share it through another secure channel. The user must change it at first sign-in.",
  "至少 {{min}} 位": "At least {{min}} characters",
  "{{min}}–128 位；对方首次登录后必须自行更换": "{{min}}–128 characters; the user must change it at first sign-in",
  "两次输入的密码不一致": "Passwords do not match",
  "确认初始密码": "Confirm initial password",
  "请再次输入初始密码": "Enter the initial password again",
  "发送重置密码邮件？": "Send password reset email?",
  "将向 {{email}} 发送一封包含重置链接的邮件，链接只能使用一次。": "An email with a single-use password reset link will be sent to {{email}}.",
  "如果 {{email}} 对应一个账号，重置邮件已发送": "If an account exists for {{email}}, a reset email has been sent",
  "发送": "Send",
  "重置密码邮件": "Password reset email",
  "部门筛选": "Department filter",
  "部门": "Department",
  "刷新部门": "Refresh departments",
  "搜索部门": "Search departments",
  "全部用户": "All users",
  "未分配": "Unassigned",
  "没有匹配的部门": "No matching departments",
  "编辑用户": "Edit user",
  "已保存 {{name}} 的资料": "Profile saved for {{name}}",
  "邮箱是登录身份的依据，不在这里修改": "Email identifies the sign-in account and cannot be changed here",
  "姓": "Last name",
  "例如：张": "e.g. Smith",
  "名": "First name",
  "例如：三": "e.g. Alex",
  "手机号": "Phone number",
  "例如：138 0000 0000": "e.g. 138 0000 0000",
  "性别": "Gender",
  "未填写": "Not provided",
  "男": "Male",
  "女": "Female",
  "其他": "Other",
  "生日": "Birthday",
  "例如：1990-01-01": "e.g. 1990-01-01",
  "账号身份": "Account role",
  "内置管理员拥有全部权限；业务权限通过下方业务角色分配。": "Built-in administrators have all permissions; assign business permissions using the roles below.",
  "只给管理员看的说明，例如所属团队或创建原因": "Administrator-only notes, such as team or reason for creation",
  "新建用户": "New user",
  "用户已创建": "User created",
  "用户已创建，初始密码已发放，对方首次登录时必须修改": "User created and initial password issued; it must be changed at first sign-in",
  "用户已创建，但初始密码发放失败：{{error}}。可在列表里点「发初始密码」重试": "User created, but issuing the initial password failed: {{error}}. Retry with “Issue initial password” in the user list.",
  "初始密码（可选）": "Initial password (optional)",
  "留空则稍后再发": "Leave blank to issue later",
  "8–128 位；对方首次登录后必须自行更换": "8–128 characters; the user must change it at first sign-in",
  "留空则暂不发放登录密码，之后可以在列表里补发。": "Leave blank to issue a sign-in password later from the user list.",
  "重新启用": "Re-enable",
  "恢复当前租户访问，不影响其他租户或账号封禁。": "Restore access to this tenant without affecting other tenants or account bans.",
  "仅停用当前租户档案；资料和照片保留，不影响其他租户。": "Only this tenant profile will be disabled. Details and photos are retained; other tenants are unaffected.",
  "停用这个用户？": "Disable this user?",
  "重新启用这个用户？": "Re-enable this user?",
  "已{{action}} {{name}}": "{{action}}: {{name}}",
  "冒充用户": "Impersonate user",
  "发初始密码": "Issue initial password",
  "登录会话": "Sign-in sessions",
  "冒充 {{name}}？": "Impersonate {{name}}?",
  "将切换为该用户身份，按其权限执行操作；可通过页面顶部「停止冒充」返回管理员。": "Switch to this user's identity and permissions. Select “Stop impersonating” at the top of the page to return to your administrator account.",
  "{{name}} 的登录会话": "Sign-in sessions for {{name}}",
  "未知设备": "Unknown device",
  "浏览器未识别": "Unrecognized browser",
  "该会话已撤销": "Session revoked",
  "该用户的全部会话已撤销": "All sessions for this user revoked",
  "该用户当前没有登录会话": "This user has no sign-in sessions",
  "有效登录会话": "Active sign-in sessions",
  "撤销后，该设备需要重新登录。": "The device will need to sign in again after revocation.",
  "撤销该用户的全部会话？": "Revoke all sessions for this user?",
  "他会在所有设备上被登出，需要重新登录。": "The user will be signed out on all devices and must sign in again.",
  "全部撤销": "Revoke all",
  "未知": "Unknown",
  "撤销这条会话？": "Revoke this session?",
  "该设备会被登出，需要重新登录。": "This device will be signed out and must sign in again.",
  "撤销": "Revoke",
  "登录时间": "Signed in at",
  "到期时间": "Expires at",
  "浏览器标识": "User agent",
  "用户": "User",
  "登录身份": "Sign-in access",
  "已开通": "Available",
  "未开通": "Not available",
  "最近登录方式": "Last sign-in method",
  "详情": "Details",
  "用户列表": "Users",
  "用户导出.xlsx": "users-export.xlsx",
  "已导出 {{count}} 条": "Exported {{count}} records",
  "导出用户": "Export users",
  "导入用户": "Import users",
  "预检未通过，请修正文件后重新选择": "Validation failed. Fix the file and select it again.",
  "已导入 {{count}} 条": "Imported {{count}} records",
  "数据已变化，请修正文件后重新选择；本批次未导入": "Data has changed. Fix the file and select it again; no records in this batch were imported.",
  "用户导入模板.xlsx": "users-import-template.xlsx",
  "确认导入": "Confirm import",
  "仅新增普通用户档案，不覆盖已有用户或创建登录凭据。最多 100 行、1 MiB，解析内容最多 90 KiB；生日使用 YYYY-MM-DD，部门填写当前租户的部门编号。": "Adds regular user profiles only, without overwriting existing users or creating sign-in credentials. Maximum 100 rows, 1 MiB file and 90 KiB parsed content. Use YYYY-MM-DD for birthdays and department IDs from the current tenant.",
  "下载模板": "Download template",
  "选择文件并预检": "Select file and validate",
  "共 {{total}} 行，可导入 {{valid}} 行；有错误时整批不写入。": "{{total}} rows, {{valid}} valid; no rows are imported if any errors exist.",
  "行号": "Row",
  "名字": "First name",
  "姓氏": "Last name",
  "电话": "Phone",
  "部门编号": "Department ID",
  "预检结果": "Validation result",
  "通过": "Passed",
  "请输入合法的邮箱地址": "Enter a valid email address",
  "邮箱最长 254 个字符": "Email must be at most 254 characters",
  "密码至少 {{min}} 位": "Password must be at least {{min}} characters",
  "密码最长 128 位": "Password must be at most 128 characters",
  "请输入姓名": "Enter your name",
  "姓名最长 64 个字符": "Name must be at most 64 characters",
  "请输入名": "Enter a first name",
  "名最长 64 个字符": "First name must be at most 64 characters",
  "请输入姓": "Enter a last name",
  "姓最长 64 个字符": "Last name must be at most 64 characters",
  "请输入合法的手机号": "Enter a valid phone number",
  "请选择合法的日期": "Select a valid date",
  "备注最长 500 个字符": "Notes must be at most 500 characters",
  "请输入密码": "Enter your password",
  "请再次输入密码": "Enter your password again",
  "普通用户": "Standard user",
  "文件不能超过 1 MiB": "File must not exceed 1 MiB",
  "请选择有效的 .xlsx 文件": "Select a valid .xlsx file",
  "文件必须只包含一张工作表": "File must contain exactly one worksheet",
  "每次最多导入 100 行，请拆分文件": "Import up to 100 rows at a time; split the file",
  "请使用未合并单元格的导入模板": "Use the import template without merged cells",
  "表头含公式，请使用文本表头": "Headers contain formulas; use text headers",
  "表头重复或含不支持的列，请使用导入模板": "Duplicate or unsupported headers; use the import template",
  "缺少邮箱、名字或姓氏列": "Missing email, first name or last name column",
  "第 {{row}} 行含公式，请改为文本或数值": "Row {{row}} contains formulas; use text or numbers",
  "第 {{row}} 行生日不合法": "Invalid birthday in row {{row}}",
  "第 {{row}} 行单元格过长": "Cell value in row {{row}} is too long",
  "文件没有可导入的数据": "File contains no importable data",
  "导入内容不能超过 90 KiB，请拆分文件": "Parsed content must not exceed 90 KiB; split the file",
  "请选择 .xlsx 文件": "Select an .xlsx file",
  "解析已取消": "Parsing canceled",
  "Excel 解析超时，请简化文件后重试": "Excel parsing timed out; simplify the file and try again",
  "Excel 解析失败": "Excel parsing failed",
  "Excel 解析失败，文件可能损坏或已加密": "Excel parsing failed; the file may be damaged or encrypted",
  "运营工作台": "Operations workbench",
  "个人中心": "My account",
  "系统设置": "System settings",
  "用户管理": "Users",
  "字典管理": "Dictionaries",
  "配置管理": "Configuration",
  "日志管理": "Logs",
  "协议与隐私": "Agreements and privacy",
  "文件列表": "Files",
  "存储配置": "Storage configuration",
  "会话管理": "Sessions",
  "Redis 缓存": "Redis cache",
  "服务监控": "Service monitoring",
  "任务中心": "Tasks",
  "通知中心": "Notifications",
  "系统管理": "System management",
  "文件管理": "File management",
  "系统监控": "System monitoring",
  "默认租户": "Default tenant",
  "用户查看": "View users",
  "用户维护": "Manage users",
  "字典查看": "View dictionaries",
  "字典维护": "Manage dictionaries",
  "系统配置查看": "View system configuration",
  "系统配置维护": "Manage system configuration",
  "角色查看": "View roles",
  "角色维护及授权": "Manage roles and permissions",
  "岗位查看": "View positions",
  "岗位维护及分配": "Manage positions and assignments",
  "部门查看": "View departments",
  "部门维护": "Manage departments",
  "菜单查看": "View menus",
  "菜单维护": "Manage menus",
  "文件查看": "View files",
  "文件上传": "Upload files",
  "文件及文件夹整理": "Organize files and folders",
  "文件下载及预览": "Download and preview files",
  "文件删除": "Delete files",
  "存储配置查看": "View storage configuration",
  "存储配置维护（仅授予可信运维）": "Manage storage configuration (trusted operators only)",
  "地址与上传这类应用自身的参数。": "Application settings such as URLs and uploads.",
  "密码强度、会话前置条件与两步验证。": "Password strength, session requirements and two-factor authentication.",
  "登录、注册与找回密码前的人机校验。": "CAPTCHA before sign-in, registration and password recovery.",
  "验证与重置邮件怎么发出去。": "Delivery of verification and password reset emails.",
  "成对出现才会启用一个 provider。": "Each provider requires a complete credential pair.",
  "JWT 签发参数；业务路由已不再接受 Bearer JWT。": "JWT issuance settings; business routes no longer accept Bearer JWTs.",
  "Trace 与指标上报。": "Trace and metrics reporting.",
  "这些键必须留在 .env：读取、解密或定义了信任边界，改不了也不该改。": "These keys must remain in .env: they enable configuration access, decryption or define trust boundaries.",
  "应用": "Application",
  "IP 归属地": "IP location",
  "阿里云市场 IP 查询，重启 API 后生效。": "Alibaba Cloud Marketplace IP lookup. Restart the API to apply changes.",
  "AppKey": "AppKey",
  "AppSecret": "AppSecret",
  "AppCode": "AppCode",
  "未配置 AppCode 时，与 AppSecret 配套用于签名认证。": "Used with AppSecret for signature authentication when AppCode is not configured.",
  "与 AppKey 配套；加密保存且不回显。": "Used with AppKey. Encrypted at rest and never displayed.",
  "优先使用 AppCode 认证；加密保存且不回显。": "AppCode authentication takes priority. Encrypted at rest and never displayed.",
  "认证策略": "Authentication policy",
  "人机校验": "CAPTCHA",
  "邮件": "Email",
  "第三方登录": "Social sign-in",
  "令牌": "Tokens",
  "可观测性": "Observability",
  "环境变量（锁定）": "Environment variables (locked)",
  "自定义": "Custom",
  "前端地址": "Frontend URL",
  "上传上限（字节）": "Upload limit (bytes)",
  "密码最短长度": "Minimum password length",
  "拦截泄露口令": "Block compromised passwords",
  "要求邮箱已验证": "Require verified email",
  "两步验证发行者": "Two-factor issuer",
  "设备授权客户端白名单": "Device authorization client allowlist",
  "设备验证页面": "Device verification page",
  "启用人机校验": "Enable CAPTCHA",
  "服务商": "Provider",
  "服务端密钥": "Server secret",
  "站点公钥": "Site key",
  "发送方式": "Delivery method",
  "邮件标题": "Email subject",
  "英文邮件标题": "English email subject",
  "支持 {subject} 自动填入邮件用途，如「爱出海 - {subject}」；也可填写完整标题。最多 200 字符，重启 API 后生效。": "Use {subject} for the email purpose, e.g. iGlobal - {subject}, or enter a full subject. Maximum 200 characters. Takes effect after restarting the API.",
  "发件人": "Sender",
  "outbox 目录": "Outbox directory",
  "SMTP 主机": "SMTP host",
  "SMTP 端口": "SMTP port",
  "SMTP 隐式 TLS": "SMTP implicit TLS",
  "SMTP 用户": "SMTP username",
  "SMTP 口令": "SMTP password",
  "JWT 签名密钥": "JWT signing secret",
  "签发者（iss）": "Issuer (iss)",
  "受众（aud）": "Audience (aud)",
  "启用上报": "Enable reporting",
  "服务标识": "Service identifier",
  "服务版本": "Service version",
  "上报地址": "Reporting endpoint",
  "链路采样率": "Trace sampling rate",
  "运行告警 Webhook": "Operations alert webhook",
  "告警接收器令牌": "Alert receiver token",
  "任务进程模式": "Task process mode",
  "任务 Redis 前缀": "Task Redis prefix",
  "运行环境": "Runtime environment",
  "监听端口": "Listen port",
  "数据库连接串": "Database connection string",
  "Redis 连接串": "Redis connection string",
  "API 公开 origin": "Public API origin",
  "会话密钥": "Session secret",
  "认证共享限流": "Shared authentication rate limit",
  "可信代理 IP": "Trusted proxy IPs",
  "存储密钥口令": "Storage encryption passphrase",
  "配置表密钥口令": "Configuration encryption passphrase",
  "允许后台重启服务": "Allow service restart from admin UI",
  "验证与重置邮件里的链接指向这里：是浏览器应用，不是 API。生产必须 HTTPS。": "Verification and reset emails link to this browser application, not the API. HTTPS is required in production.",
  "单个上传文件的字节上限，默认 5242880（5 MiB）；单条路由可以要求更小。": "Maximum bytes per uploaded file; defaults to 5242880 (5 MiB). Individual routes may set a lower limit.",
  "设置密码（注册 / 重置 / 改密）时的下限，8–128，默认 12。它不参与登录校验：调低之后已有的短口令仍能登录。": "Minimum length when setting a password (registration / reset / change): 8–128, default 12. Not applied during sign-in; existing shorter passwords remain valid after lowering it.",
  "开启时拒绝出现在 Pwned Passwords 语料里的密码。它是 fail-closed 的：查询服务不可达就拒绝写入。": "Reject passwords found in Pwned Passwords. Fails closed: password changes are rejected if the lookup service is unavailable.",
  "开启后未验证邮箱的账号不建立会话。对历史账号等于一次性集体锁定，默认关闭。": "Prevents sessions for unverified email addresses, including existing accounts. Disabled by default.",
  "认证器 App 里显示在此账号验证码旁的名字。": "The name shown beside this account's code in authenticator apps.",
  "逗号分隔的显式 client id 清单，不支持 *。留空会让设备授权拒绝所有客户端。": "Comma-separated explicit client IDs; * is unsupported. Leaving it blank rejects all device authorization clients.",
  "设备授权流程里用户确认页面的地址；生产必须 HTTPS。": "URL of the user confirmation page for device authorization. HTTPS is required in production.",
  "默认关闭；开启后需配置服务商及公私钥。": "Disabled by default; configure a provider and public/secret keys to enable.",
  "开启人机校验时必填，四选一。": "Required when CAPTCHA is enabled; select one of four providers.",
  "只留在服务端，永远不要交给浏览器。": "Server-side only; never expose this to the browser.",
  "开启人机校验时必填，供浏览器渲染验证码组件；不是服务端密钥。": "Required when CAPTCHA is enabled to render the browser widget; this is not the server secret.",
  "smtp / resend / chuanglan 发送真实邮件；outbox 仅写本地文件。切换后重启 API 生效。": "smtp / resend / chuanglan send real emails; outbox only writes local files. Restart the API after switching.",
  "真实发送时必填，支持「名称 <邮箱>」；创蓝须使用已授权的发件邮箱。": "Required for real delivery. Supports Name <email>; Chuanglan requires an authorized sender address.",
  "创蓝 InnoMail": "Chuanglan InnoMail",
  "创蓝邮件 API 地址": "Chuanglan Mail API URL",
  "创蓝邮件 AppID": "Chuanglan Mail AppID",
  "创蓝邮件 AppSecret": "Chuanglan Mail AppSecret",
  "默认 https://api.innomails.com；填写平台提供的 HTTPS 域名，不含接口路径。": "Defaults to https://api.innomails.com. Use the HTTPS origin provided by the platform, without an API path.",
  "选择创蓝 InnoMail 时必填，与邮件 AppSecret 配套；不使用短信凭据。": "Required for Chuanglan InnoMail. Use the mail AppID paired with the mail AppSecret, not SMS credentials.",
  "选择创蓝 InnoMail 时必填；加密存储，接口不返回明文。": "Required for Chuanglan InnoMail. Encrypted at rest and never returned in plaintext.",
  "outbox 方式下每条消息落一个 JSON 文件的位置。": "Directory where outbox writes one JSON file per message.",
  "AUTH_MAIL_TRANSPORT=smtp 时必填；其余方式可留空。": "Required when AUTH_MAIL_TRANSPORT=smtp; optional for other delivery methods.",
  "默认 587。": "Default: 587.",
  "465 端口用 true；587（STARTTLS）或明文中继用 false。": "Use true for port 465; false for port 587 (STARTTLS) or a plaintext relay.",
  "可选；不填表示中继不要求认证。": "Optional; leave blank if the relay does not require authentication.",
  "与 SMTP_USER 配套；加密存储，接口不再返回。": "Used with SMTP_USER; encrypted at rest and never returned by the API.",
  "AUTH_MAIL_TRANSPORT=resend 时必填；加密存储。": "Required when AUTH_MAIL_TRANSPORT=resend; encrypted at rest.",
  "与下面的 Secret 必须同时提供：只配一半启动即失败，而不是静默不启用。": "Must be provided together with the secret below. An incomplete pair prevents startup rather than silently disabling the provider.",
  "加密存储，接口不再返回。": "Encrypted at rest; never returned by the API.",
  "与下面的 Secret 必须同时提供。": "Must be provided together with the secret below.",
  "至少 32 字节。业务路由已改为会话鉴权，此密钥仅供其它签发用途。": "At least 32 bytes. Business routes use session authentication; this secret is only for other token issuance.",
  "签发与验签都要匹配的 iss。": "The iss value must match during signing and verification.",
  "签发与验签都要匹配的 aud。": "The aud value must match during signing and verification.",
  "默认关闭；开启时必须同时给出 App Key 与 App Secret。": "Disabled by default; requires both App Key and App Secret when enabled.",
  "上报凭据的标识部分；真正的秘密在 App Secret。": "The identifier portion of reporting credentials; the secret is in App Secret.",
  "默认 nest-api。": "Default: nest-api.",
  "可选；用于区分不同发布。": "Optional; distinguishes releases.",
  "只允许 HTTPS，或本地调试用的回环 HTTP。": "HTTPS only, except loopback HTTP for local debugging.",
  "0 到 1 之间，默认 0.1。": "Between 0 and 1; default 0.1.",
  "默认关闭；仅配置受信任接收器，生产要求 HTTPS。": "Disabled by default. Configure trusted receivers only; HTTPS is required in production.",
  "外部发送目的地只能由部署环境提供。": "External delivery destinations must be provided by the deployment environment.",
  "可选 Bearer 令牌，不通过后台读取或设置。": "Optional Bearer token; cannot be read or set from the admin UI.",
  "外部发送凭据只能由部署环境提供。": "External delivery credentials must be provided by the deployment environment.",
  "默认 worker；off 可关闭，worker 需要常驻进程。": "Defaults to worker. Use off to disable; worker requires a persistent process.",
  "部署决定是否消费后台任务，不能通过配置表启动 Worker。": "The deployment determines whether to consume background tasks; the configuration table cannot start a worker.",
  "同一环境所有 API / Worker 使用相同前缀，不同环境使用不同前缀。": "All API / worker processes in one environment must share a prefix; separate environments need different prefixes.",
  "部署隔离边界，改变前缀会切换任务队列。": "Deployment isolation boundary: changing the prefix switches task queues.",
  "development / test / production，默认 development。": "development / test / production; default development.",
  "进程级：同一个镜像的不同副本可以不同，且多处校验（如验证码、HTTPS）以它为前提。": "Process-level setting: replicas of one image may differ. Validation such as CAPTCHA and HTTPS depends on it.",
  "默认 3000。": "Default: 3000.",
  "进程级：端口由部署编排决定，同一个镜像的副本之间通常就不一样。": "Process-level setting: the deployment orchestrator assigns ports, which often differ across replicas.",
  "PostgreSQL 连接串；迁移另见 DIRECT_URL。": "PostgreSQL connection string; see DIRECT_URL for migrations.",
  "读这张表本身就要用它：配置不能来自一个还没有连上的数据库。": "Required to read this table: configuration cannot come from a database before connecting to it.",
  "redis:// 或 rediss://。": "redis:// or rediss://.",
  "同上。缓存连接也不该依赖数据库是否可用，否则数据库一抖动就连缓存一起没了。": "Cache connections must not depend on database availability; otherwise a database outage would also disconnect the cache.",
  "会话 Cookie 与 Origin 校验的基准地址。": "Base origin for session cookies and Origin validation.",
  "它就是信任边界：能改它的人可以改 API 接受哪个 Origin，所以它留在部署里。": "This defines a trust boundary: changing it changes the origins accepted by the API, so it is deployment-managed.",
  "至少 32 字节的高熵密钥。": "A high-entropy secret of at least 32 bytes.",
  "会话的信任根。轮换它等于让全部会话失效，那是一次发布动作，不是一次页面编辑。": "The session trust root. Rotation invalidates all sessions and must be handled as a deployment, not a UI edit.",
  "未设置时仅生产启用；生产禁止关闭。计数使用 Redis，会话仍存 PostgreSQL。": "Enabled by default only in production, where it cannot be disabled. Counters use Redis; sessions remain in PostgreSQL.",
  "部署级安全策略，不能通过后台关闭生产限流。": "Deployment-level security policy; production rate limiting cannot be disabled from the admin UI.",
  "精确 IP allowlist，逗号分隔；仅接受这些 socket peer 覆写的单值 x-real-ip。": "Comma-separated exact IP allowlist; only these socket peers may supply a single-value x-real-ip override.",
  "代理信任边界必须由部署维护，禁止通过系统配置表扩大信任。": "Proxy trust boundaries must be deployment-managed; the configuration table cannot expand trust.",
  "可选；未设置时从 BETTER_AUTH_SECRET 派生独立存储密钥。": "Optional; derives a separate storage key from BETTER_AUTH_SECRET when unset.",
  "密钥和被它保护的数据不能放在一起：这张表里的密文要拿它才读得出来。": "The key cannot be stored alongside the data it protects; it is required to decrypt this table.",
  "可选；未设置时使用存储密钥，包括自动派生的密钥。": "Optional; uses the storage key, including the automatically derived key, when unset.",
  "同上，并且它就是这张表的密钥：放进表里等于把钥匙锁进它开的柜子。": "This table's decryption key cannot be stored in the encrypted table itself.",
  "「配置管理」页面上「重启服务」按钮是否可用；不设置时按 NODE_ENV 决定：production 默认开启，其它默认关闭。": "Controls the Restart service button on the Configuration page. If unset, enabled in production and disabled elsewhere based on NODE_ENV.",
  "进程级：重启的实现是结束本进程，能不能回来取决于部署怎么拉起它（容器重启策略 / systemd / pm2）。本机开发默认没有这层守护进程，所以那里默认关闭，避免按钮把 dev server 关掉后再也起不来。": "Process-level setting: restarting exits the process. Recovery depends on a supervisor (container restart policy / systemd / pm2). Disabled by default in local development, where a supervisor is usually absent.",
  "本部署设置了 SERVICE_RESTART_ENABLED=false，API 不会自行重启。": "This deployment set SERVICE_RESTART_ENABLED=false, so the API does not restart itself here.",
  "开发和测试进程没有守护进程，退出后不会自动重启。如需启用按钮，请设置 SERVICE_RESTART_ENABLED=true。": "Development and test processes have no supervisor to restart the API after it exits. Set SERVICE_RESTART_ENABLED=true to enable this button.",
  "邮件日志": "Email logs",
  "本地发件箱": "Local outbox",
  "仅保存到本地": "Saved locally only",
  "收件人": "Recipient",
  "输入完整邮箱": "Enter the full email address",
  "邮件主题": "Email subject",
  "邮件详情": "Email details",
  "服务商请求 ID": "Provider request ID",
  "幂等键": "Idempotency key",
  "错误码": "Error code",
  "官网地址": "Official website URL",
  "商家端顶部官网入口，保存后刷新页面生效。": "Merchant header website link. Refresh the page after saving to apply.",
  "密码最长 64 位": "Password must be at most 64 characters",
  "密码须包含字母和数字": "Password must contain letters and numbers",
  "{{min}}–64 位，须含字母和数字；对方首次登录后必须自行更换": "{{min}}–64 characters with letters and numbers; change at first sign-in",
  "8–64 位，须含字母和数字；对方首次登录后必须自行更换": "8–64 characters with letters and numbers; change at first sign-in",
  "设置密码（注册 / 重置 / 改密）时的下限，8–64，默认 8，且须包含字母和数字。它不参与登录校验：调低之后已有的短口令仍能登录。": "Minimum length when setting a password: 8–64, default 8, with letters and numbers required. Existing passwords remain valid for sign-in."
}
